<template>
  <div>
    <h2>
      Size Limits
    </h2>
    <el-form
      ref="form"
      :rules="rules"
      :model="item"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            label="Minimum"
            prop="items_min"
          >
            <el-input
              v-model="item.items_min"
              type="number"
              placeholder="Minimum"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Maximum"
            prop="items_max"
          >
            <el-input
              v-model="item.items_max"
              type="number"
              placeholder="Maximum"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    }

  },
  data () {
    return {
      itemModel: null,
      rules: {
        items_min: [
          { required: true, message: 'Item Minimum is required.', trigger: ['blur'] }
        ],
        items_max: [
          { required: true, message: 'Item Maximum is required.', trigger: ['blur'] }
        ]
      }
    }
  },
  methods: {
  }
}
</script>
